import { render, staticRenderFns } from "./TagTriggerBtn.component.vue?vue&type=template&id=64bc9600&scoped=true&"
import script from "./TagTriggerBtn.component.vue?vue&type=script&lang=js&"
export * from "./TagTriggerBtn.component.vue?vue&type=script&lang=js&"
import style0 from "./TagTriggerBtn.component.vue?vue&type=style&index=0&id=64bc9600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc9600",
  null
  
)

export default component.exports